<template id="admin-shipping">
  <section>
    <div class="d-flex justify-content-between align-items-center flex-wrap">
      <h4 class="mb-0">{{ isAmazon ? 'Amazon Shipment (Excel)' : 'Delhivery Create Shipment' }}</h4>
      <b-button variant="secondary" size="sm" to="/admin/orders">
        <font-awesome-icon :icon="['far','arrow-left']"></font-awesome-icon>
        Orders
      </b-button>
    </div>

    <b-alert show variant="warning" v-if="!orderIds.length" class="mt-3">
      No orders selected, select orders in the Orders page and choose the Amazon / Delhivery action.
    </b-alert>

    <div class="d-flex flex-wrap align-items-end mt-3" v-if="shipments.length">
      <template v-if="isAmazon">
        <b-form-group label="Pickup Date" class="mr-3">
          <b-form-input type="date" v-model="date"/>
        </b-form-group>
        <b-form-group label="Pickup Time" class="mr-3">
          <b-form-select v-model="time" :options="['11:00 - 14:00', '14:00 - 16:15']"/>
        </b-form-group>
      </template>
      <b-form-group label="Box size (w x h x l cm) & weight (kg) for all" class="mr-3">
        <b-input-group>
          <b-form-input type="number" v-model.number="all.w" placeholder="w" min="5" max="50"/>
          <b-form-input type="number" v-model.number="all.h" placeholder="h" min="5" max="50"/>
          <b-form-input type="number" v-model.number="all.l" placeholder="l" min="5" max="50"/>
          <b-form-input type="number" v-model.number="all.weight" placeholder="kg" step="any"/>
          <b-input-group-append>
            <b-button variant="outline-info" @click="applyAll">Apply to all</b-button>
          </b-input-group-append>
        </b-input-group>
      </b-form-group>
    </div>

    <div class="row">
      <div class="col-sm-12 col-md-6 col-lg-4 col-xl-3 p-2" v-for="s of shipments" :key="s.orderId">
        <b-card :border-variant="cardVariant(s)" class="h-100 bg-transparent">
          <template #header>
            <div class="d-flex justify-content-between align-items-center">
              <strong>#{{ s.orderNum }} <small class="text-muted">{{ s.orderName }}</small></strong>
              <b-button size="sm" variant="link" class="text-danger p-0" title="Remove from this batch"
                        @click="remove(s)" v-if="!done(s)">
                <font-awesome-icon :icon="['far','times']"></font-awesome-icon>
              </b-button>
            </div>
          </template>

          <b-alert show variant="success" class="mb-0" v-if="done(s)">
            Shipped &mdash; tracking <code>{{ s.trackingNumber }}</code>
          </b-alert>
          <template v-else>
            <b-alert show variant="danger" v-if="errors[s.orderId]" class="small">
              <div v-for="e of errors[s.orderId]" :key="e">{{ e }}</div>
            </b-alert>
            <b-form-group label="Name of Person">
              <b-form-input v-model="s.name"/>
            </b-form-group>
            <b-form-group label="Phone Number">
              <b-form-input v-model="s.phone" :state="s.phone.trim().length === 10 ? null : false"/>
            </b-form-group>
            <b-form-group :label="`Address Line 1 ${isAmazon ? `(${s.address1.length}/60)` : ''}`">
              <b-form-textarea v-model="s.address1" rows="2" :state="lenState(s.address1)"/>
            </b-form-group>
            <b-form-group :label="`Address Line 2 ${isAmazon ? `(${s.address2.length}/60)` : ''}`">
              <b-form-textarea v-model="s.address2" rows="2" :state="lenState(s.address2)"/>
            </b-form-group>
            <div class="d-flex">
              <b-form-group label="City" class="mr-2 flex-grow-1">
                <b-form-input v-model="s.city"/>
              </b-form-group>
              <b-form-group label="Pincode" style="max-width: 110px">
                <b-form-input v-model="s.pincode" :state="s.pincode.trim().length === 6 ? null : false"/>
              </b-form-group>
            </div>
            <b-form-group label="State">
              <b-form-select v-model="s.state" :options="states" :state="s.state ? null : false">
                <template #first>
                  <b-form-select-option value="">-- select state --</b-form-select-option>
                </template>
              </b-form-select>
            </b-form-group>
            <b-form-group label="Box size (w x h x l cm)">
              <b-input-group>
                <b-form-input type="number" v-model.number="s.w" placeholder="w" min="5" max="50"/>
                <b-form-input type="number" v-model.number="s.h" placeholder="h" min="5" max="50"/>
                <b-form-input type="number" v-model.number="s.l" placeholder="l" min="5" max="50"/>
              </b-input-group>
            </b-form-group>
            <b-form-group label="Weight (kg)" class="mb-0">
              <b-form-input type="number" step="any" v-model.number="s.weight" placeholder="weight"/>
            </b-form-group>
          </template>
        </b-card>
      </div>
    </div>

    <div class="d-flex justify-content-center my-4" v-if="shipments.length">
      <b-button v-if="isAmazon" variant="success" size="lg" :disabled="busy" @click="downloadExcel">
        <font-awesome-icon :icon="['far','file-excel']"></font-awesome-icon>
        Download Excel
      </b-button>
      <template v-else>
        <b-button variant="success" size="lg" class="mr-3" :disabled="busy || !pending.length" @click="createDelhivery">
          <b-spinner small v-if="busy"></b-spinner>
          <font-awesome-icon v-else :icon="['far','truck']"></font-awesome-icon>
          Create {{ pending.length }} Delhivery Shipment(s)
        </b-button>
        <b-button-group size="lg" class="mr-3">
          <b-button variant="primary" :disabled="labelBusy || !shipped.length" @click="printLabels">
            <b-spinner small v-if="labelBusy"></b-spinner>
            <font-awesome-icon v-else :icon="['far','print']"></font-awesome-icon>
            Print {{ shipped.length }} Label(s)
          </b-button>
          <b-dropdown variant="primary" right :disabled="labelBusy || !shipped.length" :text="layoutLabel">
            <b-dropdown-item v-for="o of layouts" :key="o.value" :active="layout === o.value"
                             @click="setLayout(o.value)">
              {{ o.text }}
              <div class="small text-muted">{{ o.hint }}</div>
            </b-dropdown-item>
          </b-dropdown>
          <b-button variant="outline-primary" :disabled="labelBusy || !shipped.length" @click="downloadLabels"
                    title="Save the label PDF instead of opening it">
            <font-awesome-icon :icon="['far','file-pdf']"></font-awesome-icon>
          </b-button>
        </b-button-group>
        <b-button variant="info" size="lg" :disabled="!shipped.length" @click="openPickup">
          <font-awesome-icon :icon="['far','clock']"></font-awesome-icon>
          Schedule Pickup
        </b-button>
      </template>
    </div>

    <p class="text-center text-muted small" v-if="!isAmazon && shipped.length">
      Labels are the ones Delhivery generates for the waybill, so what the courier scans is what
      the courier produced. Their sheet is A4 with the label in one corner &mdash; the whitespace is
      cropped off before printing.
    </p>

    <b-card v-if="isAmazon && orderIds.length" class="bg-transparent mb-5" title="Upload Amazon result file">
      <p class="text-muted small">
        After uploading the excel on Amazon, download the processed file and upload it here, the orders get
        marked as shipped and customers are informed with the tracking link.
      </p>
      <b-input-group>
        <b-form-file v-model="resultFile" accept=".xlsx" placeholder="Choose processed file"/>
        <b-input-group-append>
          <b-button variant="success" :disabled="!resultFile || busy" @click="importAmazon">Upload</b-button>
        </b-input-group-append>
      </b-input-group>
      <b-table v-if="importResults" :items="importResults" :fields="importFields" small class="mt-3" show-empty
               empty-text="No rows found in the file">
        <template #cell(success)="{ item }">
          <b-badge :variant="item.success ? 'success' : 'danger'">{{ item.success ? 'shipped' : 'skipped' }}</b-badge>
        </template>
      </b-table>
    </b-card>

    <b-modal id="modal-pickup" title="Schedule a Delhivery Pickup" :ok-disabled="pickupBusy"
             ok-title="Request Pickup" @ok.prevent="requestPickup">
      <p class="text-muted small">
        Delhivery holds one open pickup per warehouse &mdash; a second request is refused until the
        first lot has been collected.
      </p>
      <b-alert show variant="danger" v-if="pickupError" class="small">{{ pickupError }}</b-alert>
      <b-alert show variant="success" v-if="pickupResult" class="small">
        Pickup <code>{{ pickupResult.pickupId }}</code> scheduled for
        {{ pickupResult.pickupDate }} at {{ pickupResult.pickupTime }} from
        {{ pickupResult.pickupLocationName }}
        <span v-if="pickupResult.incomingCenterName">&rarr; {{ pickupResult.incomingCenterName }}</span>
      </b-alert>
      <div class="d-flex">
        <b-form-group label="Pickup Date" class="mr-2 flex-grow-1">
          <b-form-input type="date" v-model="pickup.date"/>
        </b-form-group>
        <b-form-group label="Pickup Time" class="flex-grow-1">
          <b-form-input type="time" step="1" v-model="pickup.time"/>
        </b-form-group>
      </div>
      <b-form-group label="Expected Package Count">
        <b-form-input type="number" min="1" v-model.number="pickup.packageCount"/>
      </b-form-group>
      <b-form-group label="Warehouse">
        <b-form-input v-model="pickup.location" placeholder="leave blank to use the configured warehouse"/>
        <b-form-text>
          Must match the pickup location name registered with Delhivery, character for character.
        </b-form-text>
      </b-form-group>
    </b-modal>
  </section>
</template>
<script>
import axios from 'axios'
import fileDownload from 'js-file-download'
import {format} from 'date-fns'

const DIMS_KEY = 'shipping-box-dims'
const LAYOUT_KEY = 'shipping-label-layout'

// Mirrors LabelLayout on the api.
const LAYOUTS = [
  {value: 'TRIM', text: 'One per page', hint: 'cropped to the label, for A6 stock'},
  {value: 'A4_4UP', text: '4 per A4 sheet', hint: 'cropped and tiled, for a desktop printer'},
  {value: 'RAW', text: "Delhivery's A4 page", hint: 'untouched, label in one corner'}
]

export default {
  name: 'AdminShipping',
  data: () => ({
    states: [],
    shipments: [],
    errors: {},
    date: format(new Date(), 'yyyy-MM-dd'),
    time: '11:00 - 14:00',
    all: {w: null, h: null, l: null, weight: null},
    busy: false,
    labelBusy: false,
    layout: 'TRIM',
    layouts: LAYOUTS,
    pickupBusy: false,
    pickup: {date: format(new Date(), 'yyyy-MM-dd'), time: '16:00:00', packageCount: 1, location: ''},
    pickupError: '',
    pickupResult: null,
    resultFile: null,
    importResults: null,
    importFields: [
      {key: 'orderNum', label: 'Order'},
      {key: 'trackingNumber', label: 'Tracking'},
      {key: 'success', label: 'Status'},
      {key: 'error', label: 'Remarks'},
    ]
  }),
  computed: {
    service() {
      return this.$route.params.service
    },
    isAmazon() {
      return this.service === 'amazon'
    },
    orderIds() {
      return (this.$route.query.ids || '').split(',').filter(Boolean)
    },
    pending() {
      return this.shipments.filter(s => !this.done(s))
    },
    shipped() {
      return this.shipments.filter(s => this.done(s))
    },
    layoutLabel() {
      const o = LAYOUTS.find(x => x.value === this.layout)
      return o ? o.text : this.layout
    }
  },
  watch: {
    '$route': 'load'
  },
  created() {
    try {
      Object.assign(this.all, JSON.parse(localStorage.getItem(DIMS_KEY)) || {})
      const saved = localStorage.getItem(LAYOUT_KEY)
      if (LAYOUTS.some(o => o.value === saved)) this.layout = saved
    } catch (e) {
      // ignore
    }
    this.load()
  },
  methods: {
    async load() {
      this.errors = {}
      this.importResults = null
      if (!this.orderIds.length) {
        this.shipments = []
        return
      }
      const {data} = await axios.post('/api/admin/shipping/prefill', {orderIds: this.orderIds})
      this.states = data.states
      this.shipments = data.shipments.map(s => ({
        ...s,
        w: this.all.w, h: this.all.h, l: this.all.l, weight: this.all.weight
      }))
    },
    done(s) {
      return !this.isAmazon && s.modeOfShipment === 'DELHIVERY' && !!s.trackingNumber
    },
    remove(s) {
      this.shipments = this.shipments.filter(x => x !== s)
    },
    applyAll() {
      this.pending.forEach(s => Object.assign(s, this.all))
      try {
        localStorage.setItem(DIMS_KEY, JSON.stringify(this.all))
      } catch (e) {
        // ignore
      }
    },
    lenState(v) {
      return this.isAmazon && v.length > 60 ? false : null
    },
    cardVariant(s) {
      if (this.errors[s.orderId]) return 'danger'
      if (this.done(s)) return 'success'
      return null
    },
    // mirrors the api validation, so the user sees issues before hitting the server
    validate(list) {
      const errors = {}
      list.forEach(s => {
        const e = []
        if (!s.name.trim()) e.push('name is required')
        if (s.phone.trim().length !== 10) e.push('phone must be 10 digits')
        if (s.pincode.trim().length !== 6) e.push('pincode must be 6 digits')
        if (!s.address1.trim()) e.push('address line 1 is required')
        if (this.isAmazon && s.address1.length > 60) e.push('address line 1 is more than 60 characters')
        if (this.isAmazon && s.address2.length > 60) e.push('address line 2 is more than 60 characters')
        if (!s.city.trim()) e.push('city is required')
        if (!s.state) e.push('state is required')
        if (!s.w || !s.h || !s.l) e.push('box size (w x h x l) is required')
        if (!(s.weight > 0)) e.push('weight is required')
        if (e.length) errors[s.orderId] = e
      })
      this.errors = errors
      if (Object.keys(errors).length) {
        this.$bvToast.toast('Please fix the highlighted orders', {title: 'Oops!', variant: 'danger', solid: true})
        return false
      }
      return true
    },
    serverErrors(e) {
      const d = e.response && e.response.data
      if (d && d.errors) this.errors = d.errors
    },
    async downloadExcel() {
      if (!this.validate(this.shipments)) return
      this.busy = true
      try {
        const res = await axios.post('/api/admin/shipping/amazon/excel', {
          date: this.date,
          time: this.time,
          shipments: this.shipments
        }, {responseType: 'blob'})
        fileDownload(res.data, `AmazonUpload-${format(new Date(), 'dd-MM-yyyy-hh-mm-a')}.xlsx`)
      } catch (e) {
        const d = e.response && e.response.data
        if (d instanceof Blob) {
          try {
            this.serverErrors({response: {data: JSON.parse(await d.text())}})
          } catch (ignore) {
            // not json
          }
        }
      } finally {
        this.busy = false
      }
    },
    async importAmazon() {
      const fd = new FormData()
      fd.append('file', this.resultFile)
      this.busy = true
      try {
        const {data} = await axios.post('/api/admin/shipping/amazon/import', fd)
        this.importResults = data
        const ok = data.filter(r => r.success).length
        this.$bvToast.toast(`${ok} order(s) marked as shipped`, {title: 'Amazon', variant: 'success', solid: true})
        this.resultFile = null
      } finally {
        this.busy = false
      }
    },
    async createDelhivery() {
      const list = this.pending
      if (!this.validate(list)) return
      this.busy = true
      try {
        const {data} = await axios.post('/api/admin/shipping/delhivery', {shipments: list})
        const errors = {}
        data.forEach(r => {
          const s = this.shipments.find(x => x.orderId === r.orderId)
          if (!s) return
          if (r.success) {
            s.trackingNumber = r.trackingNumber
            s.modeOfShipment = 'DELHIVERY'
          } else {
            errors[r.orderId] = [r.error || 'failed to create shipment']
          }
        })
        this.errors = errors
        const ok = data.filter(r => r.success).length
        this.$bvToast.toast(`${ok} of ${data.length} shipment(s) created`, {
          title: 'Delhivery',
          variant: ok === data.length ? 'success' : 'warning',
          solid: true
        })
      } catch (e) {
        this.serverErrors(e)
      } finally {
        this.busy = false
      }
    },
    /**
     * The label Delhivery itself generates for the waybill. The api calls their Generate
     * Shipping Label endpoint and staples the per-waybill PDFs into one file; this asks by
     * order, so reprinting an older batch works the same way.
     */
    async labelPdf() {
      const res = await axios.post('/api/admin/shipping/delhivery/label', {
        orderIds: this.shipped.map(s => s.orderId),
        layout: this.layout
      }, {responseType: 'blob'})
      const skipped = res.headers['x-labels-skipped']
      if (skipped) {
        this.$bvToast.toast(`${skipped.split(',').length} of ${this.shipped.length} are not on the sheet — no waybill, or Delhivery would not render one`, {
          title: 'Delhivery', variant: 'warning', solid: true, noAutoHide: true
        })
      }
      return new Blob([res.data], {type: 'application/pdf'})
    },
    async printLabels() {
      this.labelBusy = true
      try {
        const url = URL.createObjectURL(await this.labelPdf())
        const w = window.open(url, '_blank')
        if (!w) {
          this.$bvToast.toast('Allow popups to open the labels', {title: 'Oops!', variant: 'danger', solid: true})
          URL.revokeObjectURL(url)
          return
        }
        // The tab needs the url until it has loaded the pdf; the browser keeps the blob alive
        // for the open document after that.
        setTimeout(() => URL.revokeObjectURL(url), 60000)
      } catch (e) {
        await this.labelFailed(e)
      } finally {
        this.labelBusy = false
      }
    },
    async downloadLabels() {
      this.labelBusy = true
      try {
        fileDownload(await this.labelPdf(), `DelhiveryLabels-${format(new Date(), 'dd-MM-yyyy-hh-mm-a')}.pdf`)
      } catch (e) {
        await this.labelFailed(e)
      } finally {
        this.labelBusy = false
      }
    },
    /** The error body comes back as a blob, since the request asked for one. */
    async labelFailed(e) {
      let message = 'could not get the labels from Delhivery'
      const d = e.response && e.response.data
      if (d instanceof Blob) {
        try {
          message = JSON.parse(await d.text()).error || message
        } catch (ignore) {
          // not json
        }
      } else if (d && d.error) {
        message = d.error
      }
      this.$bvToast.toast(message, {title: 'Delhivery', variant: 'danger', solid: true, noAutoHide: true})
    },
    setLayout(v) {
      this.layout = v
      try {
        localStorage.setItem(LAYOUT_KEY, v)
      } catch (e) {
        // ignore
      }
    },
    openPickup() {
      this.pickupError = ''
      this.pickupResult = null
      this.pickup.packageCount = this.shipped.length || 1
      this.$bvModal.show('modal-pickup')
    },
    async requestPickup() {
      this.pickupError = ''
      this.pickupResult = null
      this.pickupBusy = true
      try {
        const {data} = await axios.post('/api/admin/shipping/delhivery/pickup', {
          date: this.pickup.date,
          // Delhivery wants HH:mm:ss; the time input drops the seconds when they are zero.
          time: this.pickup.time.length === 5 ? `${this.pickup.time}:00` : this.pickup.time,
          packageCount: this.pickup.packageCount,
          location: this.pickup.location,
          orderIds: this.shipped.map(s => s.orderId)
        })
        this.pickupResult = data
        this.$bvToast.toast(`Pickup ${data.pickupId} scheduled`, {
          title: 'Delhivery', variant: 'success', solid: true
        })
      } catch (e) {
        const d = e.response && e.response.data
        this.pickupError = (d && d.error) || 'Delhivery refused the pickup request'
      } finally {
        this.pickupBusy = false
      }
    }
  }
}
</script>
